import type { StatusTone } from "../data-display/StatusBadge";

export interface Appointment {
  id: string;
  workspace_id: string;
  title: string;
  description?: string | null;
  contact_id?: number | null;
  job_id?: string | null;
  assigned_to?: number | null;
  booking_page_id?: string | null;
  starts_at: string;
  ends_at: string;
  status: string;
  source: string;
  customer_name?: string | null;
  customer_email?: string | null;
  customer_phone?: string | null;
  notes?: string | null;
}

export interface BookingPage {
  id: string;
  workspace_id: string;
  slug: string;
  name: string;
  description?: string | null;
  duration_minutes: number;
  buffer_minutes: number;
  timezone: string;
  availability: Record<string, [string, string][]>;
  assigned_to?: number | null;
  active: boolean;
}

export const APPOINTMENT_STATUS_TONES: Record<string, StatusTone> = {
  scheduled: "info",
  completed: "success",
  cancelled: "neutral",
  no_show: "danger",
};

/** Monday-of-week for a date (local time). */
export const startOfWeek = (date: Date): Date => {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  const day = (d.getDay() + 6) % 7; // 0 = Monday
  d.setDate(d.getDate() - day);
  return d;
};

export const addDays = (date: Date, days: number): Date => {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
};

export const isSameDay = (a: Date, b: Date): boolean =>
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate();

export const formatTime = (iso: string): string =>
  new Date(iso).toLocaleTimeString(undefined, {
    hour: "numeric",
    minute: "2-digit",
  });

/** Calendar grid window (hours shown per day column). */
export const DAY_START_HOUR = 7;
export const DAY_END_HOUR = 20;
